<template>
  <v-dialog
      :model-value="isVisible"
      max-width="1024"
      @update:model-value="dismiss"
  >
    <v-card
        prepend-icon="mdi-check"
        title="Invoice verification"
    >
      <v-card-text>
        <v-row>
          <v-col
              cols="12"
          >
            <v-form
                ref="invoiceVerification"
            >
              <v-text-field
                  label="Invoice Id"
                  v-model="invoiceId.value"
                  :rules="invoiceId.rules"
                  :loading="isLoading"
                  required
              />
            </v-form>
          </v-col>
          <v-expand-transition>
            <v-row
                v-show="invoice.fullname !== null"
                no-gutters="true"
            >
              <v-col cols="12" md="6">
                <v-text-field
                    :model-value="invoice.fullname"
                    label="Fullname"
                    disabled="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                    :model-value="invoice.address"
                    label="Address"
                    disabled="true"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                    :model-value="invoice.manufacturer"
                    label="Manufacturer"
                    disabled="true"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                    :model-value="invoice.bank"
                    label="Bank"
                    disabled="true"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                    :model-value="invoice.bankAddress"
                    label="Bank address"
                    disabled="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                    :model-value="invoice.bankAccountNumber"
                    label="Bank account"
                    disabled="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                    :model-value="invoice.bankSwiftCode"
                    label="Bank swift code"
                    disabled="true"
                />
              </v-col>
              <v-col cols="12" :md="invoice.destination !== null ? 6 : 12">
                <v-text-field
                    :model-value="invoice.terms"
                    label="Terms"
                    disabled="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                    v-if="invoice.destination !== null"
                    :model-value="invoice.destination"
                    label="Destination"
                    disabled="true"
                />
              </v-col>
              <v-col cols="12">
                <v-table>
                  <thead>
                  <tr>
                    <th class="text-center">
                      Description
                    </th>
                    <th class="text-center">
                      Model
                    </th>
                    <th class="text-center">
                      Quantity
                    </th>
                    <th class="text-center">
                      Price
                    </th>
                    <th class="text-center">
                      Total price
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in invoice.items"
                      :key="item.description"
                  >
                    <td class="text-center">{{ item.description }}</td>
                    <td class="text-center">{{ item.model }}</td>
                    <td class="text-center">{{ item.quantity }}</td>
                    <td class="text-center">{{ item.price }}</td>
                    <td class="text-center">{{ item.totalPrice }}</td>
                  </tr>
                  <tr>
                    <td class="text-center" colspan="2">Total</td>
                    <td class="text-center" colspan="1">{{ this.invoiceTotalQuantity }}</td>
                    <td class="text-center" colspan="2">{{ this.invoiceTotalPrice }}</td>
                  </tr>
                  </tbody>
                </v-table>
              </v-col>
              <v-col cols="12">
                <small class="text-caption text-medium-emphasis">*all data must match with data in your invoice</small>
              </v-col>
            </v-row>
          </v-expand-transition>
          <v-col
              v-show="error.isVisible"
              cols="12"
          >
            <small class="text-caption text-red">{{ error.errorMessage }}</small>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>

        <v-btn
            text="Close"
            variant="plain"
            @click="dismiss"
        />

        <v-btn
            color="primary"
            text="Check"
            variant="tonal"
            @click="loadInvoice"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {numbers} from "@/common/numbers";
import {Currency} from "@/common/enum/currency";

export default {
  name: "InvoiceVerificationDialog",
  emits: ['dismiss', 'loadInvoice'],
  props: {
    isLoading: Boolean,
    isVisible: Boolean,
    invoice: {
      fullname: String,
      address: String,
      manufacturer: String,
      terms: String,
      destination: String,
      currency: String,
      items: Array,
      bank: String,
      bankAddress: String,
      bankAccountNumber: String,
      bankSwiftCode: String,
      totalQuantity: String,
      totalPrice: String
    },
    error: {
      isVisible: Boolean,
      message: String
    }
  },
  computed: {
    invoiceTotalQuantity() {
      return this.invoice.items.reduce((sum, item) => sum + item.quantity, 0)
    },
    invoiceTotalPrice() {
      return numbers.formatMoney(this.invoice.items.reduce((sum, item) => sum + item.totalPriceValue, 0), this.invoice.currency ?? Currency.USD)
    }
  },
  data() {
    return {
      invoiceId: {
        value: null,
        rules: [
          v => !!v || 'Id is required',
          v => /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/.test(v) || 'Id must be valid: 1aaaaa1aa-1111-1111-a1a1-1a1a11aa11aa',
        ],
      },
    }
  },
  methods: {
    dismiss() {
      this.invoiceId.value = null
      this.$emit('dismiss')
    },
    async loadInvoice() {
      if (!(await this.$refs.invoiceVerification.validate()).valid) {
        return
      }
      this.$emit('loadInvoice', this.invoiceId.value)
    }
  }
}
</script>

<style scoped>

</style>